import React, { useCallback } from 'react';
import isNaN from 'lodash/isNaN';
import isUndefined from 'lodash/isUndefined';
import { useDispatch } from 'react-redux';

import { xcriticalFormPropertyChange } from '@xcritical/forms';

import { InputFormField } from '@crm-framework/form-fields';

import { IRulesInputProps } from '../types';
import { PROMO_FORM_NAME } from '../consts';

export const RulesInput = ({
  onChange,
  name,
  index,
  rulesLength,
  ...rest
}: IRulesInputProps) => {
  const dispatch = useDispatch();

  const $onChange = useCallback(
    (value: string) => {
      const isAmountFrom = name.endsWith('amountFrom');
      const isAmountTo = name.endsWith('amountTo');

      if (!isUndefined(index)) {
        if (isAmountFrom) {
          const isFirstRule = index === 0;
          const ruleValueAmountFrom = Number(value);
          const ruleValueAmountTo = ruleValueAmountFrom - 0.01;

          if (
            !isFirstRule &&
            !isNaN(ruleValueAmountFrom) &&
            ruleValueAmountTo > 0
          ) {
            dispatch(
              xcriticalFormPropertyChange(
                PROMO_FORM_NAME,
                `rule.bonusConditions.${index - 1}.amountTo`,
                ruleValueAmountTo.toFixed(2)
              )
            );
          }
        }

        if (isAmountTo) {
          const ruleValueAmountTo = Number(value);
          const isLastRule = index === rulesLength - 1;

          if (!isLastRule && !isNaN(ruleValueAmountTo)) {
            const ruleValueAmountFrom = ruleValueAmountTo + 0.01;

            if (ruleValueAmountFrom > 0) {
              dispatch(
                xcriticalFormPropertyChange(
                  PROMO_FORM_NAME,
                  `rule.bonusConditions.${index + 1}.amountFrom`,
                  ruleValueAmountFrom.toFixed(2)
                )
              );
            }
          }
        }
      }

      onChange(value);
    },
    [onChange, name, dispatch, index, rulesLength]
  );

  return <InputFormField name={name} onChange={$onChange} {...rest} />;
};
